module.exports = __webpack_public_path__ + "static/ReclaimerGamesLogo-9203009064e5f4e33af7ee9899f6dc15.png";